<!-- <h4 class="gen-title">{{ "credit_clearance" | langVal }}</h4> -->
<div>
  <button
    titleLang="create_takbull_account"
    tabindex="-1"
    class="btn btn-primary"
    (click)="openCreateTakbullAccount()"
  >
    {{ "create_takbull_account" | langVal }}
  </button>
</div>
<div>
  <button
    titleLang="create_grow_account"
    tabindex="-1"
    class="btn btn-primary"
    (click)="openCreateGrowAccount()"
  >
    {{ "create_grow_account" | langVal }}
  </button>
</div>


